import { fmt } from "../../format";
import { Icon } from "../../icons";
import { DropdownMenu } from "../DropdownMenu/DropdownMenu";
import { canCombine, organizationMenuItems, selectedOrganization, type SwitcherOrganization, switcherTitle } from "./organizationMenu";

export type { SwitcherOrganization } from "./organizationMenu";

export interface OrganizationSwitcherProps {
  organizations: SwitcherOrganization[];
  /** The organization in view (or where new items go, in the combined view). */
  selectedId: string | null;
  /** True when all organizations are shown together. */
  combined: boolean;
  onSelect: (organizationId: string) => void;
  onCombine: () => void;
}

const MENU_MIN_WIDTH = 300;

/**
 * The organization the person is working in, at the bottom of the sidebar: pick one, or look at all
 * of them together so there's no need to keep switching.
 */
export function OrganizationSwitcher({ organizations, selectedId, combined, onSelect, onCombine }: OrganizationSwitcherProps): React.JSX.Element | null {
  if (organizations.length === 0) return null;
  const choice = { organizations, selectedId, combined };
  const title = switcherTitle(choice);

  return (
    <DropdownMenu
      align="start"
      minWidth={MENU_MIN_WIDTH}
      ariaLabel="Organizations"
      items={organizationMenuItems(choice, onSelect, onCombine)}
      trigger={(props) => (
        <button type="button" className="nb-org-switch" aria-label={`Organization: ${title}. Change`} {...props}>
          <span className="nb-org-switch-avatar" aria-hidden="true">
            {combined ? <Icon name="layers" /> : fmt.initials(selectedOrganization(choice)?.name ?? "")}
          </span>
          <span className="nb-side-foot-text nb-org-switch-text">
            <small>{combined ? "Combined view" : "Organization"}</small>
            <span>{title}</span>
          </span>
          {canCombine(organizations) ? <Icon name="chevronsUpDown" className="nb-side-foot-text nb-org-switch-chevron" /> : null}
        </button>
      )}
    />
  );
}
